import React, { createContext, useContext, useState } from 'react'

const StoreContext = createContext({ mode: null, bottomInset: null, serverISOString: null })
export const useStore = () => useContext(StoreContext)

export default function StoreProvider({ children, initialValues }) {
  const [value, setValue] = useState(initialValues)
  return <StoreContext.Provider value={{ store: value, setStore: setValue }}>{children}</StoreContext.Provider>
}
